import React, { useEffect, useRef, useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';
import { BookingCalendarMonth } from './month/BookingCalendarMonth';
type Props = {
  className?: string;
  isLoading?: boolean;
  months: Array<{
    id: number;
    isActive: boolean;
    name: string;
    price: string | null | undefined;
    shortName: string;
    year: number;
  }>;
  onClick: (id: number) => void;
};
export const BookingCalendarMonths = ({
  className,
  isLoading = false,
  months = [],
  onClick,
}: Props) => {
  const [hovering, setHovering] = useState(null);
  const [initialPosition, setInitialPosition] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    if (ref?.current) {
      setInitialPosition(months.findIndex((m) => m.isActive));
    }
  }, [isLoading]);
  const { isTablet, isDesktop } = useResponsive();
  const containerWidth = ref?.current?.clientWidth || 0;
  // eslint-disable-next-line no-nested-ternary
  const width = !isTablet
    ? containerWidth / 4
    : isDesktop
      ? containerWidth / 8
      : containerWidth / 5;
  const elementWidth = isTablet ? width : width * 0.95;
  return (
    <div className={('relative isolate', className)}>
      <Scrollable
        backwardLabel={t('booking.common.previousMonths')}
        className="z-1"
        controlsClassName="mb-20 pb-10 sm:pb-20"
        deltaScrollFactorClick={elementWidth * 2}
        elementWidth={elementWidth}
        forwardLabel={t('booking.common.nextMonths')}
        initialPosition={elementWidth ? initialPosition : null}
        theme="calendar"
      >
        <div className="mx-5 mb-20 flex sm:mx-15 md:mx-0" ref={ref}>
          {months.map((month) => (
            <div
              className={classnames(
                'relative flex-none px-5 transition-width duration-250 ease-in sm:px-10',
                {
                  'w-1/4 sm:w-1/5 md:w-1/8': !month.isActive && hovering !== month.id,
                  'w-1/2 sm:w-2/5 md:w-1/4': month.isActive,
                  'w-3/10 sm:w-1/4 md:w-1/6': !month.isActive && hovering === month.id,
                },
              )}
              key={month.id}
              onMouseEnter={() => setHovering(month.id)}
              onMouseLeave={() => setHovering(null)}
              style={
                !isTablet && elementWidth
                  ? {
                      width: month.isActive ? elementWidth * 2 : elementWidth,
                    }
                  : null
              }
            >
              <BookingCalendarMonth
                {...month}
                className="mb-10 h-52 sm:mb-15 md:h-84"
                onClick={onClick}
              />
              {month.isActive && (
                <div className="arrow-down arrow-large arrow-lightSand arrow-bg arrow-bg-large arrow-bg-ultramarine bottom-0 start-0 -mb-1 w-full border-b-2 border-ultramarine transition-opacity duration-250 ease-in" />
              )}
            </div>
          ))}
        </div>
      </Scrollable>
      <hr className="border-ligthGrey absolute z-0 m-0 -mt-20 block h-1 w-full border-0 border-t-1 border-solid p-0" />
    </div>
  );
};
